import React, { useState, useEffect } from "react";
import { RiCloseLine } from "react-icons/ri";
import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  Grid,
  Stack,
  TextField,
  Typography,
  Box,
  InputAdornment,
  IconButton,
  List,
  ListItem,
} from "@mui/material";
import "../../../../styles/dashboard.scss";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../redux/slices/common.slice";
import DeleteIcon from "@mui/icons-material/Delete";
import CustomizedDialog from "../../Dialog";

import {
  createTraining,
  updateTraining,
} from "../../../../redux/slices/employees.slice";
import logAnalyticsEvent from "../../../../firebase/analyticsLogger";
import { useSelector } from "react-redux";
import { Link, redirect } from "react-router-dom";
import OpenInNewIcon from "@mui/icons-material/OpenInNew"; // Icon for redirect
import { AddCircleOutline } from "@mui/icons-material";

const BootstrapInput = {
  "& label": {
    width: "100%",
    "&.Mui-focused": {
      color: "#273167",
    },
  },
  "& .MuiOutlinedInput-root": {
    "& .Mui-disabled": {
      backgroundColor: "rgba(39, 49, 103, 0.1)",
    },
    "&.Mui-focused": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#273167 !important",
        borderWidth: "1px !important",
      },
    },
    "&:hover": {
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#273167 !important",
        borderWidth: "1px !important",
      },
    },
  },
};

const CreateTraining = (
  { isOpenDrawer, setIsOpenDrawer, drawerState, values, fetchAlltasks },
  props
) => {
  const [initialValues, setInitialValues] = useState({
    // due_date: "",

    // users: [],
    title: "",
    description: "",
    web_url: [""],
  });
  // const [urls, setUrls] = useState([""]);

  const isUrlValid = (url) => {
    const pattern = new RegExp(
      "^(https?:\\/\\/|www\\.)" + // protocol or www
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "localhost|" +
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$", // fragment locator
      "i"
    );
    return pattern.test(url);
  };

  const validationSchema = yup.object({
    title: yup.string().required("Title is required"),

    description: yup.string().required("Description is required"),
    web_url: yup.array().of(
      yup
        .string()
        .test(
          "isValidUrl",
          "Invalid URL format",
          (value) => !value || isUrlValid(value)
        ) // Allow empty or valid URL
    ),
  });

  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const [isLoading, setIsLoading] = useState(false);
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (valuess) => {
      setIsLoading(true);

      try {
        let response = await dispatch(
          drawerState === "edit"
            ? updateTraining({
                data: {
                  ...valuess,
                  web_url: valuess?.web_url?.filter((item) => item !== ""),
                },
                id: values?.id,
              })
            : createTraining({
                data: {
                  ...valuess,
                  web_url: valuess?.web_url?.filter((item) => item !== ""),
                },
              })
        );
        const { payload } = response;
        if (payload && payload.status) {
          await dispatch(
            setSnackbar({
              open: true,
              severity: "success",
              message:
                drawerState === "edit"
                  ? "Training Updated Succesfully."
                  : "Training Created Succesfully.",
            })
          );
          setIsOpenDrawer(false);
          fetchAlltasks();
          formik.resetForm();

          if (drawerState === "create") {
            logAnalyticsEvent("create_training", {
              user_id: user?.data?.user?.id,
            });
          } else {
            logAnalyticsEvent("edit_training", {
              user_id: user?.data?.user?.id,
            });
          }
        } else {
          await dispatch(
            setSnackbar({
              open: true,
              severity: "error",
              message: payload.message || "Internal server error",
            })
          );
        }
      } catch (error) {
        await dispatch(
          setSnackbar({
            open: true,
            severity: "error",
            message: error || "Internal server error",
          })
        );
      }
      setIsLoading(false);
    },
  });

  const handleAddUrl = () => {
    // setUrls((prevUrls) => [...prevUrls, ""]);
    if (formik.values.web_url)
      formik.setFieldValue("web_url", [...formik.values.web_url, ""]);
    else {
      formik.setFieldValue("web_url", [""]);
    }
  };

  // Remove a specific URL
  const handleRemoveUrl = (index) => {
    // setUrls((prevUrls) => prevUrls.filter((_, i) => i !== index));
    formik.setFieldValue(
      "web_url",
      formik.values.web_url?.filter((_, i) => i !== index)
    );
  };

  const handleCloseDrawer = () => {
    formik.resetForm();
    setIsOpenDrawer(false);
  };
  const setTrainingData = async () => {
    const obj = {
      title: values.title,
      description: values.description,
      web_url: values.web_url,
    };
    formik.setValues(obj);
  };
  useEffect(() => {
    if (drawerState !== "create") setTrainingData();
  }, [drawerState]);

  return (
    <>
      <CustomizedDialog
        className="modal-scroll"
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        // slots={{ backdrop: Backdrop }}
        title={
          drawerState === "view"
            ? "Training Detail"
            : drawerState === "create"
            ? "Create Training"
            : "Edit Training"
        }
        open={isOpenDrawer}
        handleClose={() => {
          handleCloseDrawer();
        }}
      >
        <DialogContent>
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Box variant="div" component="div" sx={BootstrapInput}>
                  <Typography variant="body1" component="label">
                    Title
                  </Typography>
                  <TextField
                    disabled={drawerState === "view"}
                    fullWidth
                    id="outlined-basic"
                    label=""
                    variant="outlined"
                    placeholder="Enter Title"
                    size="small"
                    name="title"
                    className={drawerState === "view" && "form-disabled"}
                    {...formik.getFieldProps("title")}
                  />
                  {formik.touched.title && formik.errors.title && (
                    <div className="form-error-message">
                      {formik.errors.title}
                    </div>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Box variant="div" component="div" sx={BootstrapInput}>
                  <Typography variant="body1" component="label">
                    Description
                  </Typography>
                  <TextField
                    disabled={drawerState === "view"}
                    fullWidth
                    id="outlined-basic"
                    label=""
                    multiline
                    minRows={5}
                    maxRows={10}
                    variant="outlined"
                    placeholder="Enter Description"
                    size="small"
                    name="description"
                    className={drawerState === "view" && "form-disabled"}
                    {...formik.getFieldProps("description")}
                  />
                  {formik.touched.description && formik.errors.description && (
                    <div className="form-error-message">
                      {formik.errors.description}
                    </div>
                  )}
                </Box>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Box component="div" sx={{ marginBottom: 2 }}>
                  <Typography
                    variant="body1"
                    component="label"
                    sx={{ marginBottom: 1, display: "block" }}
                  >
                    Web URLs
                  </Typography>
                  {drawerState === "view" ? (
                    <ul>
                      {formik.values?.web_url?.map((url, index) => (
                        <li>
                          <Link
                            to={
                              url.startsWith("http://") ||
                              url.startsWith("https://")
                                ? url
                                : `https://${url}`
                            }
                          >
                            {url}
                          </Link>
                        </li>
                      ))}{" "}
                    </ul>
                  ) : (
                    formik.values?.web_url?.map((url, index) => (
                      <Box mb={2}>
                        <Box
                          key={index}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <TextField
                            fullWidth
                            id={`web-url-${index}`}
                            type="url"
                            name={`web_urls[${index}]`}
                            value={url}
                            placeholder="Enter a valid URL"
                            size="small"
                            variant="outlined"
                            sx={{
                              "& input": {
                                fontFamily: "Arial, sans-serif",
                                fontSize: "14px",
                              },
                            }}
                            onChange={(e) => {
                              const newUrls = [...formik.values?.web_url];
                              newUrls[index] = e.target.value;
                              // setUrls(newUrls);
                              formik.setFieldValue("web_url", newUrls);
                            }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  {isUrlValid(url) ? (
                                    <Link
                                      to={
                                        url.startsWith("http://") ||
                                        url.startsWith("https://")
                                          ? url
                                          : `https://${url}`
                                      }
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ textDecoration: "none" }}
                                    >
                                      <IconButton color="primary">
                                        <OpenInNewIcon />
                                      </IconButton>
                                    </Link>
                                  ) : (
                                    <IconButton color="primary" disabled>
                                      <OpenInNewIcon />
                                    </IconButton>
                                  )}
                                </InputAdornment>
                              ),
                            }}
                            error={Boolean(
                              formik.touched.web_url?.[index] &&
                                formik.errors.web_url?.[index]
                            )}
                          />

                          <IconButton
                            color="secondary"
                            onClick={() => handleRemoveUrl(index)}
                            sx={{ marginLeft: 1 }}
                          >
                            <DeleteIcon sx={{ color: "#036185" }} />
                          </IconButton>
                        </Box>
                        {formik.touched.web_url?.[index] &&
                          formik.errors.web_url?.[index] && (
                            <div className="form-error-message">
                              {formik.errors.web_url?.[index]}
                            </div>
                          )}
                      </Box>
                    ))
                  )}

                  {drawerState !== "view" && (
                    <Button
                      variant="outlined"
                      onClick={handleAddUrl}
                      sx={{ color: "#036185" }}
                      endIcon={<AddCircleOutline />}
                    >
                      Add URL
                    </Button>
                  )}

                  {/* Error message for validation */}
                </Box>
              </Grid>

              {/* <Grid item xs={12} sm={12} md={12} lg={6} xl={12}>
                <Box variant="div" component="div" sx={BootstrapInput}>
                  <Typography variant="body1" component="label">
                    Due Date
                  </Typography>
                  <TextField
                    disabled={drawerState === "view"}
                    fullWidth
                    type="date"
                    id="outlined-basic"
                    label=""
                    variant="outlined"
                    placeholder="Select Due Date"
                    size="small"
                    name="Due Date"
                    InputProps={{
                      inputProps: {
                        min: new Date().toISOString().split("T")[0],
                      }, // Restrict past dates
                    }}
                    {...formik.getFieldProps("due_date")}
                  />
                  {formik.touched.due_date && formik.errors.due_date && (
                    <div className="form-error-message">
                      {formik.errors.due_date}
                    </div>
                  )}
                </Box>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                <Box variant="div" component="div" sx={BootstrapInput}>
                  <Typography variant="body1" component="label">
                    Assigned To
                  </Typography>
                  <Selectt
                    styles={customStyles}
                    isMulti
                    size="small"
                    fullWidth
                    options={users}
                    value={formik?.values?.users}
                    onChange={(e) => {
                      formik.setFieldValue("users", e);
                    }}
                    classNamePrefix="select"
                    placeholder={"Select Users..."}
                    components={{
                      IndicatorSeparator: () => null,
                    }}
                    menuPosition="fixed"
                    menuPlacement="top"
                  ></Selectt>
                  {formik.touched.users && formik.errors.users && (
                    <div className="form-error-message">
                      {formik.errors.users}
                    </div>
                  )}
                </Box>
              </Grid> */}
            </Grid>
          </form>
        </DialogContent>
        {drawerState !== "view" && (
          <DialogActions>
            <Box className="modal-footers">
              <Stack spacing={2} direction="row">
                <Button
                  variant="contained"
                  className="primary-button"
                  disabled={isLoading}
                  onClick={formik.handleSubmit}
                >
                  {isLoading && (
                    <CircularProgress
                      size="1rem"
                      sx={{ mr: 1, zIndex: 1, position: "absolute" }}
                    />
                  )}
                  Save
                </Button>

                <Button
                  variant="outlined"
                  className="secondary-button"
                  disabled={isLoading}
                  onClick={handleCloseDrawer}
                >
                  Cancel
                </Button>
              </Stack>
            </Box>
          </DialogActions>
        )}
      </CustomizedDialog>
    </>
  );
};

export default CreateTraining;
